(() => {
  function init(root) {
    const gallery = root.querySelector('[data-pullout-gallery]');
    const picker = root.querySelector('[data-pullout-picker]');
    if (!gallery || !picker || gallery.dataset.ready) return;
    const sets = JSON.parse(gallery.querySelector('[data-pullout-images]').textContent);
    const text = JSON.parse(gallery.querySelector('[data-pullout-text]').textContent);
    const radios = [...picker.querySelectorAll('[data-pullout-colour]')];
    const image = gallery.querySelector('.ps-pullout-gallery__image');
    const thumbs = gallery.querySelector('[data-pullout-thumbs]');
    const status = gallery.querySelector('[data-pullout-status]');
    let colour = 'Gunmetal', index = 0;
    const sized = (url, width) => { const u = new URL(url); u.searchParams.set('width', width); return u.href; };
    function show(next, announce = true) {
      const photos = sets[colour]; index = (next + photos.length) % photos.length;
      const photo = photos[index];
      image.srcset = [400,600,800,1000,1400].map(w => `${sized(photo.url,w)} ${w}w`).join(',');
      image.src = sized(photo.url,1400); image.alt = photo.alt;
      thumbs.querySelectorAll('button').forEach((b,i) => { if(i === index) b.setAttribute('aria-current','true'); else b.removeAttribute('aria-current'); });
      if(announce) status.textContent = text.status.replace('__COLOUR__',colour).replace('__NUMBER__',index+1).replace('__COUNT__',photos.length);
    }
    function select(value, updateUrl = true, announce = true) {
      colour = Object.hasOwn(sets,value) ? value : 'Gunmetal';
      radios.forEach(r => { r.checked = r.value === colour; });
      thumbs.replaceChildren(...sets[colour].map((p,i) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'ps-pullout-gallery__thumb';
        b.dataset.pulloutIndex = i; b.setAttribute('aria-label',text.image.replace('__NUMBER__',i+1));
        const img = document.createElement('img'); img.src = sized(p.url,180); img.alt = p.alt; img.width = 72; img.height = 72; img.loading = 'lazy';
        b.append(img); return b;
      }));
      show(0,announce);
      if(updateUrl) { const u = new URL(location.href); u.searchParams.set('finish',colour); history.pushState(null,'',u); }
    }
    picker.addEventListener('change', e => { if(e.target.matches('[data-pullout-colour]')) select(e.target.value); });
    thumbs.addEventListener('click',e => { const b = e.target.closest('[data-pullout-index]'); if(b) show(Number(b.dataset.pulloutIndex)); });
    gallery.querySelector('[data-pullout-prev]').addEventListener('click',() => show(index-1));
    gallery.querySelector('[data-pullout-next]').addEventListener('click',() => show(index+1));
    let sx = 0, sy = 0;
    gallery.querySelector('.ps-pullout-gallery__viewer').addEventListener('touchstart',e => { sx=e.touches[0].clientX;sy=e.touches[0].clientY; },{passive:true});
    gallery.querySelector('.ps-pullout-gallery__viewer').addEventListener('touchend',e => { const dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) show(index+(dx<0?1:-1)); },{passive:true});
    window.addEventListener('popstate',() => { if(root.isConnected) select(new URL(location.href).searchParams.get('finish'),false); });
    gallery.dataset.ready = 'true';
    select(new URL(location.href).searchParams.get('finish'),false,false);
  }
  const initAll = () => document.querySelectorAll('product-info').forEach(init);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initAll); else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
